module.exports = __webpack_public_path__ + "img/SKWINKELNetActieInschrijvenA1BD39.faefa445.png";